import React, { Component } from 'react';

class AdditionalResource extends Component {
	render() {
		return (
			<a href={this.props.url} className="additionalResource" target="_blank"><h4>{this.props.text}</h4></a>
		);
	}
}

export default AdditionalResource;
